<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    :close-on-click-modal="false"
    width="500px"
    append-to-body
    @close="dialogClose"
  >
    <div v-if="isNcmNo" style="display:flex;margin-top:20px;">
      <div style="width:90%;margin-left:10px">
        <el-input ref="ncmNoTextarea" v-model="ncmNo" type="textarea" :rows="5" no="ncmNo" length="1000" @input="filterInput" @paste.native="handlePaste" />
      </div>
    </div>
    <div v-if="!isNcmNo" style="display:flex;">
      <div style="width:90%;margin-left:10px">
        <cargo-advance-select
          filterable
          :select-type="selectTypeNames.basic_data_WoodenPackageType"
          no="packagingType"
          :default-value="packagingType"
          :cache="false"
          tag-value="code"
          @parentCallBack="item=>packagingType=item.value"
        />
      </div>
    </div>
    <div slot="footer">
      <div style="display: flex">
        <div>
          <el-button v-if="isNcmNo" no="clearSave" @click="clearSave">{{ $t('CargoMsg.Cargo_ClearSave') }}</el-button>
        </div>
        <div style="padding-left: 50%">
          <el-button no="save" type="primary" @click="save">{{ $t('common.btn.confirm') }}</el-button>
          <el-button no="dialogClose" @click="dialogClose">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
export default {
  name: 'NcnEditDialog',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, default: false },
    isNcmNo: { type: Boolean, default: false }, // 区分 NcmNo
    job: { type: Object, required: true },
    containers: { type: Array, default: () => [] },
    title: { type: String, default: '' }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      innerVisible: false,
      ncmNo: '',
      packagingType: ''
    }
  },
  computed: {

  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (this.visible) {
        this.onShow()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.onShow()
    }
  },
  methods: {
    dialogClose() {
      this.$emit('update:visible', false)
    },
    onShow() {
      this.ncmNo = ''
      this.packagingType = ''
      if (this.isNcmNo) {
        if (this.containers) {
          for (const data of this.containers) {
            if (!this.ncmNo) {
              this.ncmNo = data.ncmNo
            }
            // 箱子中数据存在不同时 显示空
            if (this.ncmNo !== data.ncmNo) {
              this.ncmNo = ''
              break
            }
          }
        }
      } else {
        if (this.containers) {
          for (const data of this.containers) {
            if (!this.packagingType) {
              this.packagingType = data.woodenPackagingType
            }
            // 箱子中数据存在不同时 显示空
            if (this.packagingType !== data.woodenPackagingType) {
              this.packagingType = ''
              break
            }
          }
        }
      }
    },
    /**
     * 输入时，禁止输入非数字，以及“空格” / ; , * & - . : 等特殊字符, 数字和其他字符能输入，也能回车
     * @param value
     */
    filterInput(pastedData) {
      // 仅保留数字
      pastedData = pastedData.replace(/[^0-9\n]/g, '')
      this.ncmNo = pastedData
    },
    /**
     * 粘贴时，需要根据“空格” / ; , * & - “ 特殊字符替换为换行符， 点和冒号过滤掉。
     * @param event
     */
    handlePaste(event) {
      event.preventDefault()
      let pastedData = (event.clipboardData || window.clipboardData).getData('text')
      // 替换特殊字符为换行符，过滤掉点和冒号
      pastedData = pastedData.replace(/[\/;,*&-]/g, '\n') // 替换特殊字符为换行符
      pastedData = pastedData.replace(/[.:]/g, '') // 过滤掉点和冒号
      // 仅保留数字
      pastedData = pastedData.replace(/[^0-9\n]/g, '')
      const input = this.$refs.ncmNoTextarea.$refs.textarea
      // 保存当前光标位置
      const cursorPos = input.selectionStart

      // 插入处理后的内容
      this.ncmNo = this.ncmNo.slice(0, cursorPos) + pastedData + this.ncmNo.slice(cursorPos)

      // 使用 $nextTick 等待 DOM 更新
      this.$nextTick(() => {
        // 更新光标位置
        input.focus()
        input.setSelectionRange(cursorPos + pastedData.length, cursorPos + pastedData.length)
      })
    },
    save() {
      this.$emit('ncnEditChange', { isNcmNo: this.isNcmNo, ncmNo: this.ncmNo, packagingType: this.packagingType })
      this.dialogClose()
    },
    clearSave() {
      this.$emit('ncnEditChange', { isNcmNo: this.isNcmNo, ncmNo: this.ncmNo, packagingType: this.packagingType, clear: true })
      this.dialogClose()
    }
  }
}
</script>

<style scoped>

</style>
